import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const listedEnergyData = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get("https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/energy/user-listing", config);
    return response;

  } catch (error) {
    throw error;
  }
};
export const getWithDrawHistory = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get("https://p629avqlng.execute-api.us-east-1.amazonaws.com/dev/v1/withdraw-history", config);
    return response;
  } catch (error) {
    throw error;
  }
}

export const web2ListEnergySell = async (
  blockChainId,
  rate,
  amount,
  state,
  energyLimit,
  homeNumber,
  address,
  token
) => {
  console.log("request", {
    blockChainId,
    rate,
    amount,
    state,
    energyLimit,
    homeNumber,
    address,
    token,
  });

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(
      `https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/energy/listing/sell`,
      {
        blockChainId,
        rate,
        amount,
        state,
        energyLimit,
        homeNumber,
        address,
      },
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};
export const web2ListEnergyBuy = async (
  rate,
  amount,
  state,
  energyLimit,
  homeNumber,
  address,
  token
) => {
  console.log("request", {
    rate,
    amount,
    state,
    energyLimit,
    homeNumber,
    address,
    token,
  });

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(
      `https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/energy/listing/buy`,
      {
        rate,
        amount,
        state,
        energyLimit,
        homeNumber,
        address,
      },
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};

export const getEnergyListed = async (type, token) => {
  const config = {
    headers: { 
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/energy/listing?query=${type}`,
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};

export const buyListedEnergy = async (
  transactionId,
  id,
  email,
  paymentGateway,
  energyQuantity,
  listing,
  limit,
  amount,
  sellerId,
  state,
  houseNumber,
  address,
  userId,
  tradeId,
  token
) => {
  console.log("request", {
    transactionId,
    id,
    email,
    paymentGateway,
    energyQuantity,
    listing,
    limit,
    amount,
    sellerId,
    state,
    houseNumber,
    address,
    userId,
    tradeId,
    token,
  });

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(
      `https://api.dev.closecarbon.com/energy/v1/energy/buy`,
      {
        transactionId,
        id,
        email,
        paymentGateway,
        energyQuantity,
        listing,
        limit,
        amount,
        sellerId,
        state,
        houseNumber,
        address,
        userId,
        tradeId
      },
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};

export const getEnergyListedDetails = async (blockChainId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `https://api.dev.closecarbon.com/energy/v1/details?block_chain_id=${blockChainId}`,
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};

export const getEnergyOrders = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/energy/v1/energy/order/list`,
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};



